import { render, staticRenderFns } from "./ProductDisposalEmissionByWaste.vue?vue&type=template&id=e6ae53cc"
import script from "./ProductDisposalEmissionByWaste.vue?vue&type=script&lang=js"
export * from "./ProductDisposalEmissionByWaste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports